import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const defaultQuestions = [
  { question: 'What does CPU stand for?', options: ['Central Processing Unit', 'Central Process Unit', 'Computer Personal Unit', 'Central Processor Unit'], correctAnswer: 'Central Processing Unit' },
  { question: 'What is the main language used to create web pages?', options: ['Python', 'JavaScript', 'HTML', 'C++'], correctAnswer: 'HTML' },
  { question: 'What does HTTP stand for?', options: ['HyperText Transfer Protocol', 'HyperText Transmission Protocol', 'HighText Transfer Protocol', 'HyperText Transport Protocol'], correctAnswer: 'HyperText Transfer Protocol' },
  { question: 'Which company developed the Windows operating system?', options: ['Apple', 'Microsoft', 'IBM', 'Google'], correctAnswer: 'Microsoft' },
  { question: 'What is the full form of RAM?', options: ['Random Access Memory', 'Read Access Memory', 'Random Allocation Memory', 'Read Allocation Memory'], correctAnswer: 'Random Access Memory' },
  { question: 'Which programming language is primarily used for Android app development?', options: ['Swift', 'Kotlin', 'Java', 'C#'], correctAnswer: 'Java' },
  { question: 'What does URL stand for?', options: ['Uniform Resource Locator', 'Uniform Reference Locator', 'Universal Resource Locator', 'Universal Reference Locator'], correctAnswer: 'Uniform Resource Locator' },
  { question: 'Which part of the computer is considered the brain?', options: ['RAM', 'Hard Drive', 'CPU', 'GPU'], correctAnswer: 'CPU' },
  { question: 'What is the name of the first computer programmer?', options: ['Alan Turing', 'Ada Lovelace', 'Charles Babbage', 'Bill Gates'], correctAnswer: 'Ada Lovelace' },
  { question: 'Which protocol is used for sending emails?', options: ['HTTP', 'SMTP', 'FTP', 'POP3'], correctAnswer: 'SMTP' }
];

const CreateRoomPage = () => {
  const [questions, setQuestions] = useState([]);
  const [timeLimit, setTimeLimit] = useState(60);
  const [roomCreated, setRoomCreated] = useState(false);
  const [roomCode, setRoomCode] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (questions.length === 0) {
      setQuestions(defaultQuestions);
    }
  }, [questions]);

  const addQuestion = () => {
    setQuestions([...questions, { question: '', options: ['', '', '', ''], correctAnswer: '' }]);
  };

  const updateQuestion = (index, field, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index][field] = value;
    setQuestions(updatedQuestions);
  };

  const updateOption = (qIndex, oIndex, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[qIndex].options[oIndex] = value;
    setQuestions(updatedQuestions);
  };

  const createRoom = async () => {
    const response = await fetch('https://quizbk.shirazkhan.me/create-room', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ questions, timeLimit })
    });

    const data = await response.json();

    localStorage.setItem('hostId', data.roomCode);
    localStorage.setItem('roomCode', data.roomCode);

    setRoomCode(data.roomCode);
    setRoomCreated(true);
    setShowPopup(true);
  };

  const startGame = async () => {
    const response = await fetch('https://quizbk.shirazkhan.me/start-game', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ roomCode })
    });

    if (response.ok) {
      navigate(`/quiz/${roomCode}`);
    } else {
      alert('Failed to start the game.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-400 to-orange-500 flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold text-white mb-6">Create Room</h1>
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-6">
        {questions.map((q, qIndex) => (
          <div key={qIndex} className="mb-6">
            <input
              type="text"
              value={q.question}
              onChange={(e) => updateQuestion(qIndex, 'question', e.target.value)}
              placeholder="Enter question"
              className="w-full p-3 border rounded-lg mb-4"
            />
            <div className="grid grid-cols-2 gap-4">
              {q.options.map((option, oIndex) => (
                <input
                  key={oIndex}
                  type="text"
                  value={option}
                  onChange={(e) => updateOption(qIndex, oIndex, e.target.value)}
                  placeholder={`Option ${oIndex + 1}`}
                  className="p-3 border rounded-lg"
                />
              ))}
            </div>
            <select
              value={q.correctAnswer}
              onChange={(e) => updateQuestion(qIndex, 'correctAnswer', e.target.value)}
              className="mt-4 p-3 border rounded-lg w-full"
            >
              <option value="">Select Correct Answer</option>
              {q.options.map((option, oIndex) => (
                <option key={oIndex} value={option}>{option}</option>
              ))}
            </select>
          </div>
        ))}

        <button
          onClick={addQuestion}
          className="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-lg shadow-lg mb-6"
        >
          Add Question
        </button>

        <input
          type="number"
          value={timeLimit}
          onChange={(e) => setTimeLimit(e.target.value)}
          placeholder="Time limit (seconds)"
          className="w-full p-3 border rounded-lg mb-6"
        />

        <button
          onClick={createRoom}
          className="px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg shadow-lg mb-4"
        >
          Create Room
        </button>
      </div>

      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-lg text-center">
            <h2 className="text-lg font-bold mb-4">Enter this code to join the room:</h2>
            <p className="text-4xl font-bold text-green-600 mb-6">{roomCode}</p>
            <button
              onClick={startGame}
              className="px-8 py-4 bg-purple-500 hover:bg-purple-600 text-white font-bold rounded-lg shadow-lg"
            >
              Start Game
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateRoomPage;